export default {
    ID: "2",
    SLUG: "bartone",
    NAME: "Bartone",
    PRIMARY: "#000000",
    SECONDARY: "#141414",
    API: "https://api.bartone.io",
    LOGO: "/bartone/logo.png",
    APP_ICON: "/Assets/bartone/bartone.svg",
    APP_LOGO: "/Assets/bartone/bartone.svg",
    APP_NAME: "Bartone",
    APP_FAVICON: "/Assets/bartone/favicon.ico",
  };